<div class="info">
  <span class="info-title">{{ data ? data : 'An error occurred.' }}</span>
  <a class="info-close" (click)="snackBarRef.dismiss()" title="Close">
    <mat-icon>close</mat-icon>
  </a>
</div>
